<template>
  <div v-show="visivel" name="modal" class="modal-mask">
    <div class="modal-wrapper">
      <div class="w3-container w3-modal-content">

        <div class="w3-block w3-text-theme">
          <h4 class="w3-container">
            <i class="fas fa-sign-out-alt fa-fw w3-text-theme"></i>
            <span>Identificação para Retirada de Mercadorias</span>
          </h4>

          <span
            @click="fechar()"
            class="w3-button w3-display-topright"
            style="margin-top: 0;">&times;</span>
        </div>

        <div class="w3-container w3-col">
          <label>Nome</label>
          <input 
            ref="campoNome"
            class="w3-input w3-border"
            v-model="nome"
            maxlength="50" 
            style="text-transform: uppercase;"/>
        </div>

        <br>

        <div v-if="coletar_documentos">
          <div class="w3-container w3-col m6 l6">
            <label>RG / CI / RIC</label>
            <input
              v-model="rg"
              ref="campoRG"
              class="w3-input w3-border"
              maxlength="20"/>
          </div>

          <div class="w3-container w3-col m6 l6">
            <label>Órgão expedidor</label>
            <input
              v-model="orgao_expedidor"
              ref="campoOrgaoExpedidor"
              class="w3-input w3-border"
              maxlength="10"/>
          </div>

          <div class="w3-container w3-col m6 l6">
            <label>Placa do veículo</label>
            <input
              v-model="placa"
              ref="campoPlacaVeiculo"
              class="w3-input w3-border"
              maxlength="8"/>
          </div>
        </div>

        <div class="w3-container w3-col">
          <button
            class="w3-button w3-theme"
            @click="confirmar()">
            <i class="fas fa-check"></i>
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import toastr from 'toastr';
  import Biblioteca from '@/components/Repositorio/Biblioteca';

  export default {
    name: 'ColetarPessoaSaidaProdutos',

    props: {
      exigirIdentificacaoCompleta: {
        type: String,
        default: 'N',
        required: false
      }
    },

    data() {
      return {
        visivel: false,

        nome: '',
        rg: '',
        orgao_expedidor: '',
        placa: '',
        coletar_documentos: false
      }
    },

    methods: {
      abrir(coletar_documentos, nome, rg, orgao_expedidor, placa) {
        if (!Biblioteca.em(this.exigirIdentificacaoCompleta, ['S', 'N'])) {
          toastr.error('A parametrização de exigência de identificação completa deve ser "S" ou "N"!');
          return;
        }

        this.visivel = true;

        this.coletar_documentos = coletar_documentos;
        this.nome = nome;
        this.rg = rg;
        this.orgao_expedidor = orgao_expedidor;
        this.placa = placa;

        this.$nextTick(() =>this.$refs.campoNome.focus())
      },

      fechar() {
        this.visivel = false;
      },

      confirmar() {
        if (Biblioteca.stringVazia(this.nome)) {
          toastr.error('Informe o nome!');
          this.$nextTick(() =>this.$refs.campoNome.focus());
          return;
        }

        if (this.coletar_documentos) {
          if (Biblioteca.stringVazia(this.rg)) {
            toastr.error('Informe o RG!');
            this.$nextTick(() =>this.$refs.campoRG.focus());
            return;
          }

          if (Biblioteca.stringVazia(this.orgao_expedidor)) {
            toastr.error('Informe o orgão expedidor!');
            this.$nextTick(() =>this.$refs.campoOrgaoExpedidor.focus());
            return;
          }

          if (Biblioteca.stringVazia(this.placa)) {
            toastr.error('Informe a placa do veículo!');
            this.$nextTick(() =>this.$refs.campoPlacaVeiculo.focus());
            return;
          }
        }

        let retorno = {
          nome: this.nome.toUpperCase(),
          rg: this.rg,
          orgao_expedidor: this.orgao_expedidor,
          placa: this.placa
        };

        this.$emit('confirmar', retorno);
        this.visivel = false;
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    animation: animatezoom 0.6s;
    margin: auto;
    height: auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 1  2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .w3-button {
    padding: 10px;
    margin-top: 10px
  }
</style>



// WEBPACK FOOTER //
// src/components/ColetarPessoaSaidaProdutos.vue